<template>
  <ValidationProvider v-slot="{ valid, errors }" mode="aggressive" :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-input
      v-model="innerValue"
      v-bind="$attrs"
      :readonly="$attrs.readonly"
      :min="$attrs.options && $attrs.options.min ? $attrs.options.min : 0"
      :state="errors[0] ? false : (valid && rules && innerValue ? true : null)"
      :aria-describedby="`${$attrs.name}-live-feedback`"
      @update="onChange"
    ></b-form-input>
    <b-form-invalid-feedback :id="`${$attrs.name}-live-feedback`">{{ errors[0] }}</b-form-invalid-feedback>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    formValue: {
      type: Object,
      default: () => {},
    },
    // must be included in props
    value: {
      type: null,
      default: '',
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.formValue[this.$attrs.name] = newVal
      this.$emit('update-value', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    onChange(val) {
      this.$emit('update-value', val)
    }
  }
}
</script>
